export const QueueTableTypes = {
    DEFAULT: "Default",
    UNASSIGNED: "Unassigned"
}